import React, { useState } from "react";
import { useQuery } from "@apollo/react-hooks";
import { gql } from "apollo-boost";

import DisputeTable from "./DisputeTable";

const AllDisputes = () => {

  const { loading, error, data } = useQuery(ALL_DISPUTES_QUERY);

  return error ? (
    <>Error...</>
  ) : loading ? (
    <>Loading...</>
  ) : (
    <div className="fraud-list">
      <DisputeTable 
        disputes={data.getDisputes.sort((a,b) => b.created_at - a.created_at)}
      />
    </div>
  );
};

const ALL_DISPUTES_QUERY = gql`
  query AllDisputes {
    getDisputes {
      id
      created_at
      resolved_at
      status
      galileo_status
      outcome
      reason_code
      disputed_amount
      granted_amount
      transaction {
        id
        amount
      }
      User {
        email
        first_name
        last_name
      }
    }
  }
`;

export default AllDisputes;
